import React from 'react';
import { Form, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import ServiceTypeSelect from '../../../common/forms/select/ServiceTypeSelect';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import FormFooter from '../../../common/forms/FormFooter';
import { BUS_FLEET_BASE_LOCATION_IDS } from '../../../../config/constants';

const BusFleetCurrentStatusFilterForm = ({ handleSubmit, loading }) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Base">
        <Field
          name="baseLocation"
          component={LocationSelect}
          forHomeBase
          preloadLocationIds={BUS_FLEET_BASE_LOCATION_IDS}
          isClearable
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Tipo de Servicio">
        <Field
          name="serviceType"
          component={ServiceTypeSelect}
          showAll
          isClearable
          isMulti
        />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Incluir servicio Norte Chico">
        <Field name="showNorthChico" component="input" type="checkbox" />
      </FormItem>
    </FormGroup>
    <FormGroup row>
      <FormItem label="Incluir buses de mina">
        <Field name="showMine" component="input" type="checkbox" />
      </FormItem>
    </FormGroup>
    <FormFooter
      saveButtonText="Buscar"
      saveButtonIcon="fa fa-search"
      saveButtonColor="primary"
      saveButtonDisabled={loading}
    />
  </Form>
);

BusFleetCurrentStatusFilterForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

BusFleetCurrentStatusFilterForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: 'BusFleetCurrentStatusFilterForm',
})(BusFleetCurrentStatusFilterForm);
